export default {
    _1_star: '1_star',
    _2_star: '2_star',
    _3_star: '3_star',
    _click: 'click',
    _connect_the_dots_to_make_a_picture: 'connect_the_dots_to_make_a_picture',
    _final_burst: 'final_burst',
    _incorrect: 'incorrect',
    _letters_aLetter: 'letters/aLetter',
    _letters_bLetter: 'letters/bLetter',
    _letters_cLetter: 'letters/cLetter',
    _letters_dLetter: 'letters/dLetter',
    _letters_eLetter: 'letters/eLetter',
    _letters_fLetter: 'letters/fLetter',
    _letters_gLetter: 'letters/gLetter',
    _letters_hLetter: 'letters/hLetter',
    _letters_iLetter: 'letters/iLetter',
    _letters_jLetter: 'letters/jLetter',
    _letters_kLetter: 'letters/kLetter',
    _letters_lLetter: 'letters/lLetter',
    _letters_mLetter: 'letters/mLetter',
    _letters_nLetter: 'letters/nLetter',
    _letters_oLetter: 'letters/oLetter',
    _letters_pLetter: 'letters/pLetter',
    _letters_qLetter: 'letters/qLetter',
    _letters_rLetter: 'letters/rLetter',
    _letters_sLetter: 'letters/sLetter',
    _letters_tLetter: 'letters/tLetter',
    _letters_uLetter: 'letters/uLetter',
    _letters_vLetter: 'letters/vLetter',
    _letters_wLetter: 'letters/wLetter',
    _letters_xLetter: 'letters/xLetter',
    _letters_yLetter: 'letters/yLetter',
    _letters_zLetter: 'letters/zLetter',
    _picIntro1: 'picIntro1',
    _picIntro2: 'picIntro2',
    _picIntro3: 'picIntro3',
    _picture_names_big_eye_monster: 'picture_names/big_eye_monster',
    _picture_names_blue_monster: 'picture_names/blue_monster',
    _picture_names_bunny: 'picture_names/bunny',
    _picture_names_car: 'picture_names/car',
    _picture_names_checkered_flag: 'picture_names/checkered_flag',
    _picture_names_cupcake: 'picture_names/cupcake',
    _picture_names_delivery_truck: 'picture_names/delivery_truck',
    _picture_names_dinosaur: 'picture_names/dinosaur',
    _picture_names_doggie: 'picture_names/doggie',
    _picture_names_dumptruck: 'picture_names/dumptruck',
    _picture_names_fire_truck: 'picture_names/fire_truck',
    _picture_names_gear_robot: 'picture_names/gear_robot',
    _picture_names_green_monster: 'picture_names/green_monster',
    _picture_names_hammer: 'picture_names/hammer',
    _picture_names_handy_robot: 'picture_names/handy_robot',
    _picture_names_helicopter: 'picture_names/helicopter',
    _picture_names_mail_truck: 'picture_names/mail_truck',
    _picture_names_motorcycle: 'picture_names/motorcycle',
    _picture_names_octopus: 'picture_names/octopus',
    _picture_names_one_eye_monster: 'picture_names/one_eye_monster',
    _picture_names_orange_birdie: 'picture_names/orange_birdie',
    _picture_names_orange_monster: 'picture_names/orange_monster',
    _picture_names_paper_plane: 'picture_names/paper_plane',
    _picture_names_pink_monster: 'picture_names/pink_monster',
    _picture_names_playground: 'picture_names/playground',
    _picture_names_police_car: 'picture_names/police_car',
    _picture_names_race_car: 'picture_names/race_car',
    _picture_names_racecar: 'picture_names/racecar',
    _picture_names_red_birdie: 'picture_names/red_birdie',
    _picture_names_robot: 'picture_names/robot',
    _picture_names_rocketship: 'picture_names/rocketship',
    _picture_names_saw: 'picture_names/saw',
    _picture_names_school_bus: 'picture_names/school_bus',
    _picture_names_snake: 'picture_names/snake',
    _picture_names_taxi: 'picture_names/taxi',
    _picture_names_tow_truck: 'picture_names/tow_truck',
    _picture_names_tractor: 'picture_names/tractor',
    _picture_names_wheelie_robot: 'picture_names/wheelie_robot',
    _picture_names_wrench: 'picture_names/wrench',
    _picture_names_yellow_birdie: 'picture_names/yellow_birdie',
    _pop_01b: 'pop_01b',
    _pop_02b: 'pop_02b',
    _pop_06a: 'pop_06a',
    _show_dialog_sound: 'show_dialog_sound',
    _slide_whistle_up_05: 'slide_whistle_up_05',
    _Sound0: 'Sound0',
    _Sound1: 'Sound1',
    _Sound10: 'Sound10',
    _Sound100: 'Sound100',
    _Sound11: 'Sound11',
    _Sound12: 'Sound12',
    _Sound13: 'Sound13',
    _Sound14: 'Sound14',
    _Sound15: 'Sound15',
    _Sound16: 'Sound16',
    _Sound17: 'Sound17',
    _Sound18: 'Sound18',
    _Sound19: 'Sound19',
    _Sound2: 'Sound2',
    _Sound20: 'Sound20',
    _Sound21: 'Sound21',
    _Sound22: 'Sound22',
    _Sound23: 'Sound23',
    _Sound24: 'Sound24',
    _Sound25: 'Sound25',
    _Sound26: 'Sound26',
    _Sound27: 'Sound27',
    _Sound28: 'Sound28',
    _Sound29: 'Sound29',
    _Sound3: 'Sound3',
    _Sound30: 'Sound30',
    _Sound31: 'Sound31',
    _Sound32: 'Sound32',
    _Sound33: 'Sound33',
    _Sound34: 'Sound34',
    _Sound35: 'Sound35',
    _Sound36: 'Sound36',
    _Sound37: 'Sound37',
    _Sound38: 'Sound38',
    _Sound39: 'Sound39',
    _Sound4: 'Sound4',
    _Sound40: 'Sound40',
    _Sound41: 'Sound41',
    _Sound42: 'Sound42',
    _Sound43: 'Sound43',
    _Sound44: 'Sound44',
    _Sound45: 'Sound45',
    _Sound46: 'Sound46',
    _Sound47: 'Sound47',
    _Sound48: 'Sound48',
    _Sound49: 'Sound49',
    _Sound5: 'Sound5',
    _Sound50: 'Sound50',
    _Sound51: 'Sound51',
    _Sound52: 'Sound52',
    _Sound53: 'Sound53',
    _Sound54: 'Sound54',
    _Sound55: 'Sound55',
    _Sound56: 'Sound56',
    _Sound57: 'Sound57',
    _Sound58: 'Sound58',
    _Sound59: 'Sound59',
    _Sound6: 'Sound6',
    _Sound60: 'Sound60',
    _Sound61: 'Sound61',
    _Sound62: 'Sound62',
    _Sound63: 'Sound63',
    _Sound64: 'Sound64',
    _Sound65: 'Sound65',
    _Sound66: 'Sound66',
    _Sound67: 'Sound67',
    _Sound68: 'Sound68',
    _Sound69: 'Sound69',
    _Sound7: 'Sound7',
    _Sound70: 'Sound70',
    _Sound71: 'Sound71',
    _Sound72: 'Sound72',
    _Sound73: 'Sound73',
    _Sound74: 'Sound74',
    _Sound75: 'Sound75',
    _Sound76: 'Sound76',
    _Sound77: 'Sound77',
    _Sound78: 'Sound78',
    _Sound79: 'Sound79',
    _Sound8: 'Sound8',
    _Sound80: 'Sound80',
    _Sound81: 'Sound81',
    _Sound82: 'Sound82',
    _Sound83: 'Sound83',
    _Sound84: 'Sound84',
    _Sound85: 'Sound85',
    _Sound86: 'Sound86',
    _Sound87: 'Sound87',
    _Sound88: 'Sound88',
    _Sound89: 'Sound89',
    _Sound9: 'Sound9',
    _Sound90: 'Sound90',
    _Sound91: 'Sound91',
    _Sound92: 'Sound92',
    _Sound93: 'Sound93',
    _Sound94: 'Sound94',
    _Sound95: 'Sound95',
    _Sound96: 'Sound96',
    _Sound97: 'Sound97',
    _Sound98: 'Sound98',
    _Sound99: 'Sound99',
    _titles_count_by_ones: 'titles/count_by_ones',
    _titles_level1: 'titles/level1',
    _titles_level10: 'titles/level10',
    _titles_level2: 'titles/level2',
    _titles_level3: 'titles/level3',
    _titles_level4: 'titles/level4',
    _titles_level5: 'titles/level5',
    _titles_level6: 'titles/level6',
    _titles_level7: 'titles/level7',
    _titles_level8: 'titles/level8',
    _titles_level9: 'titles/level9',
    _titles_skip_count_2: 'titles/skip_count_2',
    _titles_skip_count_3: 'titles/skip_count_3',
    _titles_skip_count_4: 'titles/skip_count_4',
    _titles_skip_count_5: 'titles/skip_count_5',
    _you_made_too_many_mistakes: 'you_made_too_many_mistakes',
}